export const Pagination = {
  page: 1,
  onePage: 3
};
